import { Box, Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function SigmaIcon(props: IconProps) {
  return (
    <Icon viewBox="0 0 20 18" {...props}>
      <Box
        as="path"
        fill="#2FB2AF"
        d="m14.866 17.056-9.563-4.112h6.184l3.38 4.112ZM8.92 8.753l6.779 8.224-2.696-12.541L8.92 8.753ZM0 0l8.434 8.273 4.083-4.318L0 0Zm16.233.088-3.161 3.347-3.043-.972L16.233.088Zm.675.285-1.794 1.806L20 2.257 16.908.373Z"
      />
    </Icon>
  );
}
